import { dateUtils } from 'utils/date-utils';
import { Entity } from './common';

export interface IConnectedFiltersDto {
  StartTime: Date | string;
  EndTime?: Date | string;
  User?: Entity<string> | null;
  UserGroup?: Entity<string> | null;
  Budget?: Entity<number> | null;
  BudgetExperiment?: Entity<number> | null;
  InstituteProject?: Entity<number> | null;
  FundingType?: Entity<number> | null;
  ExternalCustomer?: Entity<number> | null;
  PurchaseOrder?: string | null;
  Reference?: string | null;
}
export const ConnectedFiltersInit = (
  StartTime?: Date | string,
  EndTime?: Date | string,
  User?: Entity<string> | null,
  UserGroup?: Entity<string> | null,
  Budget?: Entity<number> | null,
  BudgetExperiment?: Entity<number> | null,
  InstituteProject?: Entity<number> | null,
  FundingType?: Entity<number> | null,
  ExternalCustomer?: Entity<number> | null,
  PurchaseOrder?: string | null,
  Reference?: string | null,
): IConnectedFiltersDto => {
  return {
    StartTime: dateUtils.formatISO(
      dateUtils.dateOrStringToDate(StartTime || new Date()),
    ),
    EndTime: EndTime,
    User: User,
    UserGroup: UserGroup,
    Budget: Budget,
    BudgetExperiment: BudgetExperiment,
    InstituteProject: InstituteProject,
    ExternalCustomer: ExternalCustomer,
    FundingType: FundingType,
    PurchaseOrder: PurchaseOrder,
    Reference: Reference,
  };
};
